import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData,convertiTipoStorage} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import {noleggi_off,utenti_off} from "../offline/offline_costanti.js";
/* global $ */

function StorageTabella({datiStor,numeroConto}) {
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoStorage() {
    const tipoStorag=[{id:1,text:"Storage"},{id:2,text:"Storage + 3 rescue"},{id:3,text:"Assistenza spiaggia"}]
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerStorages").addClass("grid-container-hidden")
            $("#loadingOverlay").show()

            const formattedRows=datiStor.map((row,index) => ({
                id:index,
                storageid:row.storageid,
                data:convertDate(row.storageregdate).toISO({ includeOffset: false }),
                nome:row.storagecustname,
                tipo:row.storagetype,
                durata:Math.floor((convertDate(row.storageto)-convertDate(row.storagefrom))/(60*60000*24)),
                storageDa:convertDate(row.storagefrom).toISO({ includeOffset: false }),
                storageA:convertDate(row.storageto).toISO({ includeOffset: false }),
                costo:row.storagecost,
                pagato:row.storageadvance,
                metodo:row.storagepaymentmethod,
                telefono:row.storagecustphone,
                residenza:row.storagecustresidence,
                sconto:row.storagediscount,
                rescuePagati:row.storageprepaidrescues,
                rescueUsati:row.storageusedrescues,
                costo_scontato:(row.storagecost * (1 - (row.storagediscount || 0) / 100)),
            }))
            $("#gridContainerStorages").dxDataGrid({

          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_Stor").length===0) {
                $('<div id="val_reg_Stor"></div>').appendTo(cellElement)
            }
            $("#val_reg_Stor").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nome", caption: "Nome", hidingPriority: 12,alignment:allineamento, },
          { dataField: "tipo", caption: "Tipo storage", hidingPriority: 6,alignment:allineamento,
              customizeText: function (cellInfo) {
                return convertiTipoStorage(cellInfo.value)
              },
              editCellTemplate: function(cellElement,cellInfo) {
                  if ($("#val_tipo_Stor").length===0) {
                      $('<div id="val_tipo_Stor"></div>').appendTo(cellElement)
                  }

                  $("#val_tipo_Stor").dxSelectBox({dataSource:tipoStorag,valueExpr: 'id',displayExpr: 'text',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
                    cellInfo.setValue(e.value)
                    },
                  })
              }
          },
          {
            dataField: "storageDa",
            caption: "Storage da",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio_Stor").length===0) {
                $('<div id="val_inizio_Stor"></div>').appendTo(cellElement)
            }
            $("#val_inizio_Stor").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            const fine=DateTime.fromISO($("#val_fine_Stor").dxDateBox("instance").option("value"))
            const inizio=DateTime.fromISO(e.value)
            const durata=(fine-inizio)/(60*60000*24)
            var minuti=durata%60
            $("#val_durata_Stor").dxNumberBox("instance").option("value",durata)
            }})
          },
            hidingPriority: 10,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          {
            dataField: "storageA",
            caption: "Storage a",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_fine_Stor").length===0) {
                $('<div id="val_fine_Stor"></div>').appendTo(cellElement)
            }
            $("#val_fine_Stor").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            let fine=null
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
              fine=DateTime.fromJSDate(e.value)
            }
            else {
                cellInfo.setValue(e.value)
                fine=DateTime.fromISO(e.value)
            }
            const inizio=DateTime.fromISO($("#val_inizio_Stor").dxDateBox("instance").option("value"))

            const durata=(fine-inizio)/(60*60000*24)
           $("#val_durata_Stor").dxNumberBox("instance").option("value",durata)
            }})
          },
            hidingPriority: 8,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          {
            dataField: "costo",
            caption: "Costo",
            alignment:allineamento,
            hidingPriority: 11,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_Stor").length===0) {
                $('<div id="val_costo_Stor"></div>').appendTo(cellElement)
            }
            $("#val_costo_Stor").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto_Stor").dxNumberBox("instance").option("value")
            $("#val_costo_scontato_Stor").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "pagato",
            caption: "Anticipo",
            hidingPriority: 9,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo_Stor").length===0) {
                $('<div id="val_anticipo_Stor"></div>').appendTo(cellElement)
            }
            $("#val_anticipo_Stor").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "metodo", caption: "Pagamento", hidingPriority: 5,alignment:allineamento, },
          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto_Stor").length===0) {
                $('<div id="val_sconto_Stor"></div>').appendTo(cellElement)
            }
            $("#val_sconto_Stor").dxNumberBox({showSpinButtons: true,step:5,min:0,value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo_Stor").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato_Stor").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato_Stor").length===0) {
                $('<div id="val_costo_scontato_Stor"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo_Stor").dxNumberBox("instance").option("value"))*(1-($("#val_sconto_Stor").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato_Stor").dxNumberBox({showSpinButtons: true,step:10,min:0,value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato_Stor").dxNumberBox("instance").option("max",$("#val_costo_Stor").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo_Stor").dxNumberBox("instance").option("value")))*100
            $("#val_sconto_Stor").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          { dataField: "telefono", caption: "Numero cliente", hidingPriority: 4,alignment:allineamento, },
          { dataField: "residenza", caption: "Residenza cliente", hidingPriority: 3,alignment:allineamento, },
          { dataField: "rescuePagati", caption: "Rescue pagati", hidingPriority: 2,alignment:allineamento, },
          { dataField: "rescueUsati", caption: "Rescue usati", hidingPriority: 1,alignment:allineamento, },
          { dataField: "durata", visible: false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_durata_Stor").length===0) {
                $('<div id="val_durata_Stor"></div>').appendTo(cellElement)
            }
            $("#val_durata_Stor").dxNumberBox({min:0,value:cellInfo.value,format:"#' giorni'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const durationString = e.value;
            const valoreInMs = durationString*60*60000*24
            const fine=DateTime.fromMillis(DateTime.fromISO($("#val_inizio_Stor").dxDateBox("instance").option("value"))+valoreInMs).toISO({includeOffset:false})
            $("#val_fine_Stor").dxDateBox("instance").option("value",fine)

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} giorni`;
            }
          },
          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica storage",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
  colCount: 1,  // Tutti gli elementi a tutta larghezza
  items: [
    {
      itemType: "group",
      colCount: 2,
      items: ["data", "nome"],
    },
    {
      itemType: "group",
      colCount: 3,
      items: [
        { dataField: "storageDa", label: { text: "Storage da" } },
        { dataField: "storageA", label: { text: "Storage a" } },
        {dataField: "durata", label: { text: "Durata storage" } }
      ],
    },
    {
      itemType: "group",
      colCount: 2,
      items: [
        { dataField: "tipo", label: { text: "Tipo Storage" } },
        { dataField: "costo", label: { text: "Costo (€)" } },
        { dataField: "pagato", label: { text: "Pagato (€)" } },
        { dataField: "metodo", label: { text: "Metodo di pagamento" } },
        { dataField: "telefono", label: { text: "Numero cliente" } },
        { dataField: "residenza", label: { text: "Residenza cliente" } },
        { dataField: "rescuePagati", label: { text: "Rescue pagati" } },
        { dataField: "rescueUsati", label: { text: "Rescue usati" } },
        { dataField: "sconto", label: { text: "Sconto (%)" } },
        { dataField: "costo_scontato", label: { text: "Costo scontato" } },
      ],
    },
  ],
}

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && (e.dataField === "data"||e.dataField === "storageDa"||e.dataField==="storageA")) {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=tipoStorag
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'id',displayExpr: 'text',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        e.data.data=DateTime.now().toISODate()
        e.data.storageDa=DateTime.now().toISODate()
        e.data.rescueUsati=0
        e.data.tipo=1
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerStorages"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            console.log(convertDate(DateTime.fromISO(e.data.storageDa)),e.data.storageDa)
            const dati_n={'storagediscount':e.data.sconto,'storagecustname':e.data.nome,'storagetype':e.data.tipo,'storagecost':e.data.costo,'storageadvance':e.data.pagato,'storagepaymentmethod':e.data.metodo,"storagecustphone":e.data.telefono,"storagecustresidence":e.data.residenza,"storagefrom":convertDate(DateTime.fromISO(e.data.storageDa)),"storageto":convertDate(DateTime.fromISO(e.data.storageA)),"storageregdate":convertDate(DateTime.fromISO(e.data.data)),"storageprepaidrescues":e.data.rescuePagati,"storageusedrescues":e.data.rescueUsati};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setStorage'})
                if (richiesta) {
                    const message = `Storage di ${e.data.nome} aggiunto con successo`;
                    window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerStorages',

                        },}, "success", 500);
                    const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"billid":numeroConto},
                        azione: "getStorages",
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                storageid:row.storageid,
                data:convertDate(row.storageregdate).toISO({ includeOffset: false }),
                nome:row.storagecustname,
                tipo:row.storagetype,
                storageDa:convertDate(row.storagefrom).toISO({ includeOffset: false }),
                storageA:convertDate(row.storageto).toISO({ includeOffset: false }),
                costo:row.storagecost,
                pagato:row.storageadvance,
                metodo:row.storagepaymentmethod,
                telefono:row.storagecustphone,
                residenza:row.storagecustresidence,
                sconto:row.storagediscount,
                rescuePagati:row.storageprepaidrescues,
                rescueUsati:row.storageusedrescues,
                costo_scontato:(row.storagecost * (1 - (row.storagediscount || 0) / 100)),
            }))
                      $("#gridContainerStorages").dxDataGrid("instance").option("dataSource",formattedRows)
                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerStorages"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            const dati_n={'storagediscount':e.data.sconto,'storagecustname':e.data.nome,'storagetype':e.data.tipo,'storagecost':e.data.costo,'storageadvance':e.data.pagato,'storagepaymentmethod':e.data.metodo,"storagecustphone":e.data.telefono,"storagecustresidence":e.data.residenza,"storagefrom":convertDate(DateTime.fromISO(e.data.storageDa)),"storageto":convertDate(DateTime.fromISO(e.data.storageA)),"storageregdate":convertDate(DateTime.fromISO(e.data.data)),"storageprepaidrescues":e.data.rescuePagati,"storageusedrescues":e.data.rescueUsati};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.storageid,
                valori:dati_n,
                azione:'setStorage'})
                if (richiesta) {
                const message = `Storage di ${e.data.nome} modificato con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerStorages',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.storageid,
                azione:'delStorage',
                return_data:false})
            if (richiesta) {
                const message = `Storage di ${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerStorages',

                },}, "success", 500);}
        },

        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerStorages").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo_scontato);
            const rescueP = e.data.rescuePagati
            const rescueU=e.data.rescueUsati
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)||(rescueU>rescueP)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
          })

        }
        fetchStorages()
    },[])
return (<div id="gridContainerStorages" ></div>)
}

return (<div>
        <TabellaStoricoStorage/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default StorageTabella